export default {
  styleOverrides: {
    root: {
      borderRadius: '24px'
    }
  }
};
